angular.module('unica_room.room_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// ROOM LIST AND DELETE
		.state('app.hospitality.room_list', {
			url: '/room-list/:event_id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/room/templates/list.html',
					controller: 'RoomListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Configura Stanze',
				parent: function($scope) {
					return 'app.hospitality.invitation_room_list({event_id:' + $scope.event_id + '})';
				}
			}
		})

		// ROOM CREATE
		.state('app.hospitality.room_create', {
			url: '/room-create/:event_id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/room/templates/create.html',
					controller: 'RoomCreateController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Aggiungi Stanza',
				parent: function($scope) {
					return 'app.hospitality.room_list({event_id:' + $scope.event_id + '})';
				}
			}
		})

		// ROOM EDIT
		.state('app.hospitality.room_edit', {
			url: '/room-edit/:event_id/:id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/room/templates/edit.html',
					controller: 'RoomEditController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Modifica Stanza',
				parent: function($scope) {
					return 'app.hospitality.room_list({event_id:' + $scope.event_id + '})';
				}
			}
		});




});

